import { useMonitor } from "@suse-o11y/signal";
import type { FormUnit } from "@suse-o11y/signal/form";
import React from "react";

import { Tag } from "~/components/tag";
import { Truncated } from "~/components/truncated";

import type { FormState } from "./_form-state";
import { ListVariablePreview } from "./_list-variable";

export interface PreviewProps {
	name: FormUnit<string, unknown, string>;
	state: FormState;
}

export const Preview: React.FC<PreviewProps> = ({ name, state }) => {
	const monitor = useMonitor();
	const activeType = state.fields.type.getActiveBranch(monitor);

	if (activeType?.kind === "TextVariable") {
		return (
			<Tag disabled>
				<Truncated>{activeType.value.fields.value.getOutput(monitor) || "\u00A0"}</Truncated>
			</Tag>
		);
	}

	if (activeType?.kind === "ListVariable") {
		return <ListVariablePreview name={name} state={activeType.value} />;
	}

	return null;
};
